module.exports = __webpack_public_path__ + "img/survey-icon-dark.978acb78.svg";